import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { isNativeAudioNodeFaker } from '../guards/native-audio-node-faker';
import { isOwnedByContext } from '../helpers/is-owned-by-context';
export var createPannerNodeRendererFactory = function createPannerNodeRendererFactory(connectAudioParam, createNativeChannelMergerNode, createNativeConstantSourceNode, createNativeGainNode, createNativePannerNode, getNativeAudioNode, nativeOfflineAudioContextConstructor, renderAutomation, renderInputsOfAudioNode, renderNativeOfflineAudioContext) {
  return function () {
    var renderedNativeAudioNodes = new WeakMap();
    var renderedBufferPromise = null;

    var createAudioNode = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(proxy, nativeOfflineAudioContext, trace) {
        var nativeGainNode, nativePannerNode, commonAudioNodeOptions, commonNativePannerNodeOptions, nativePannerNodeIsOwnedByContext, options, _ret;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                nativeGainNode = null;
                nativePannerNode = getNativeAudioNode(proxy);
                commonAudioNodeOptions = {
                  channelCount: nativePannerNode.channelCount,
                  channelCountMode: nativePannerNode.channelCountMode,
                  channelInterpretation: nativePannerNode.channelInterpretation
                };
                commonNativePannerNodeOptions = _objectSpread(_objectSpread({}, commonAudioNodeOptions), {}, {
                  coneInnerAngle: nativePannerNode.coneInnerAngle,
                  coneOuterAngle: nativePannerNode.coneOuterAngle,
                  coneOuterGain: nativePannerNode.coneOuterGain,
                  distanceModel: nativePannerNode.distanceModel,
                  maxDistance: nativePannerNode.maxDistance,
                  panningModel: nativePannerNode.panningModel,
                  refDistance: nativePannerNode.refDistance,
                  rolloffFactor: nativePannerNode.rolloffFactor
                }); // If the initially used nativePannerNode was not constructed on the same OfflineAudioContext it needs to be created again.

                nativePannerNodeIsOwnedByContext = isOwnedByContext(nativePannerNode, nativeOfflineAudioContext); // Bug #124: Safari does not support modifying the orientation and the position with AudioParams.

                if ('bufferSize' in nativePannerNode) {
                  nativeGainNode = createNativeGainNode(nativeOfflineAudioContext, _objectSpread(_objectSpread({}, commonAudioNodeOptions), {}, {
                    gain: 1
                  }));
                } else if (!nativePannerNodeIsOwnedByContext) {
                  options = _objectSpread(_objectSpread({}, commonNativePannerNodeOptions), {}, {
                    orientationX: nativePannerNode.orientationX.value,
                    orientationY: nativePannerNode.orientationY.value,
                    orientationZ: nativePannerNode.orientationZ.value,
                    positionX: nativePannerNode.positionX.value,
                    positionY: nativePannerNode.positionY.value,
                    positionZ: nativePannerNode.positionZ.value
                  });
                  nativePannerNode = createNativePannerNode(nativeOfflineAudioContext, options);
                }

                renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeGainNode === null ? nativePannerNode : nativeGainNode);

                if (!(nativeGainNode !== null)) {
                  _context4.next = 12;
                  break;
                }

                return _context4.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  var partialOfflineAudioContext, nativeChannelMergerNode, renderedBuffer, inputGainNode, channelDatas, i, lastOrientation, lastPosition, gateGainNode, partialPannerNode, _i, orientation, positon, currentTime;

                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!(renderedBufferPromise === null)) {
                            _context3.next = 7;
                            break;
                          }

                          if (!(nativeOfflineAudioContextConstructor === null)) {
                            _context3.next = 3;
                            break;
                          }

                          throw new Error('Missing the native OfflineAudioContext constructor.');

                        case 3:
                          partialOfflineAudioContext = new nativeOfflineAudioContextConstructor(6, // Bug #17: Safari does not yet expose the length.
                          proxy.context.length, nativeOfflineAudioContext.sampleRate);
                          nativeChannelMergerNode = createNativeChannelMergerNode(partialOfflineAudioContext, {
                            channelCount: 1,
                            channelCountMode: 'explicit',
                            channelInterpretation: 'speakers',
                            numberOfInputs: 6
                          });
                          nativeChannelMergerNode.connect(partialOfflineAudioContext.destination);
                          renderedBufferPromise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                            var nativeConstantSourceNodes, i;
                            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    _context2.next = 2;
                                    return Promise.all([proxy.orientationX, proxy.orientationY, proxy.orientationZ, proxy.positionX, proxy.positionY, proxy.positionZ].map( /*#__PURE__*/function () {
                                      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(audioParam, index) {
                                        var nativeConstantSourceNode;
                                        return _regeneratorRuntime.wrap(function _callee$(_context) {
                                          while (1) {
                                            switch (_context.prev = _context.next) {
                                              case 0:
                                                nativeConstantSourceNode = createNativeConstantSourceNode(partialOfflineAudioContext, {
                                                  channelCount: 1,
                                                  channelCountMode: 'explicit',
                                                  channelInterpretation: 'discrete',
                                                  offset: index === 0 ? 1 : 0
                                                });
                                                _context.next = 3;
                                                return renderAutomation(partialOfflineAudioContext, audioParam, nativeConstantSourceNode.offset, trace);

                                              case 3:
                                                return _context.abrupt("return", nativeConstantSourceNode);

                                              case 4:
                                              case "end":
                                                return _context.stop();
                                            }
                                          }
                                        }, _callee);
                                      }));

                                      return function (_x4, _x5) {
                                        return _ref3.apply(this, arguments);
                                      };
                                    }()));

                                  case 2:
                                    nativeConstantSourceNodes = _context2.sent;

                                    for (i = 0; i < 6; i += 1) {
                                      nativeConstantSourceNodes[i].connect(nativeChannelMergerNode, 0, i);
                                      nativeConstantSourceNodes[i].start(0);
                                    }

                                    return _context2.abrupt("return", renderNativeOfflineAudioContext(partialOfflineAudioContext));

                                  case 5:
                                  case "end":
                                    return _context2.stop();
                                }
                              }
                            }, _callee2);
                          }))();

                        case 7:
                          _context3.next = 9;
                          return renderedBufferPromise;

                        case 9:
                          renderedBuffer = _context3.sent;
                          inputGainNode = createNativeGainNode(nativeOfflineAudioContext, _objectSpread(_objectSpread({}, commonAudioNodeOptions), {}, {
                            gain: 1
                          }));
                          _context3.next = 13;
                          return renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, inputGainNode, trace);

                        case 13:
                          channelDatas = [];

                          for (i = 0; i < renderedBuffer.numberOfChannels; i += 1) {
                            channelDatas.push(renderedBuffer.getChannelData(i));
                          }

                          lastOrientation = [channelDatas[0][0], channelDatas[1][0], channelDatas[2][0]];
                          lastPosition = [channelDatas[3][0], channelDatas[4][0], channelDatas[5][0]];
                          gateGainNode = createNativeGainNode(nativeOfflineAudioContext, _objectSpread(_objectSpread({}, commonAudioNodeOptions), {}, {
                            gain: 1
                          }));
                          partialPannerNode = createNativePannerNode(nativeOfflineAudioContext, _objectSpread(_objectSpread({}, commonNativePannerNodeOptions), {}, {
                            orientationX: lastOrientation[0],
                            orientationY: lastOrientation[1],
                            orientationZ: lastOrientation[2],
                            positionX: lastPosition[0],
                            positionY: lastPosition[1],
                            positionZ: lastPosition[2]
                          }));
                          inputGainNode.connect(gateGainNode).connect(partialPannerNode.inputs[0]);
                          partialPannerNode.connect(nativeGainNode);

                          for (_i = 128; _i < renderedBuffer.length; _i += 128) {
                            orientation = [channelDatas[0][_i], channelDatas[1][_i], channelDatas[2][_i]];
                            positon = [channelDatas[3][_i], channelDatas[4][_i], channelDatas[5][_i]];

                            if (orientation.some(function (value, index) {
                              return value !== lastOrientation[index];
                            }) || positon.some(function (value, index) {
                              return value !== lastPosition[index];
                            })) {
                              lastOrientation = orientation;
                              lastPosition = positon;
                              currentTime = _i / nativeOfflineAudioContext.sampleRate;
                              gateGainNode.gain.setValueAtTime(0, currentTime);
                              gateGainNode = createNativeGainNode(nativeOfflineAudioContext, _objectSpread(_objectSpread({}, commonAudioNodeOptions), {}, {
                                gain: 0
                              }));
                              partialPannerNode = createNativePannerNode(nativeOfflineAudioContext, _objectSpread(_objectSpread({}, commonNativePannerNodeOptions), {}, {
                                orientationX: lastOrientation[0],
                                orientationY: lastOrientation[1],
                                orientationZ: lastOrientation[2],
                                positionX: lastPosition[0],
                                positionY: lastPosition[1],
                                positionZ: lastPosition[2]
                              }));
                              gateGainNode.gain.setValueAtTime(1, currentTime);
                              inputGainNode.connect(gateGainNode).connect(partialPannerNode.inputs[0]);
                              partialPannerNode.connect(nativeGainNode);
                            }
                          }

                          return _context3.abrupt("return", {
                            v: nativeGainNode
                          });

                        case 23:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })(), "t0", 9);

              case 9:
                _ret = _context4.t0;

                if (!(typeof _ret === "object")) {
                  _context4.next = 12;
                  break;
                }

                return _context4.abrupt("return", _ret.v);

              case 12:
                if (nativePannerNodeIsOwnedByContext) {
                  _context4.next = 27;
                  break;
                }

                _context4.next = 15;
                return renderAutomation(nativeOfflineAudioContext, proxy.orientationX, nativePannerNode.orientationX, trace);

              case 15:
                _context4.next = 17;
                return renderAutomation(nativeOfflineAudioContext, proxy.orientationY, nativePannerNode.orientationY, trace);

              case 17:
                _context4.next = 19;
                return renderAutomation(nativeOfflineAudioContext, proxy.orientationZ, nativePannerNode.orientationZ, trace);

              case 19:
                _context4.next = 21;
                return renderAutomation(nativeOfflineAudioContext, proxy.positionX, nativePannerNode.positionX, trace);

              case 21:
                _context4.next = 23;
                return renderAutomation(nativeOfflineAudioContext, proxy.positionY, nativePannerNode.positionY, trace);

              case 23:
                _context4.next = 25;
                return renderAutomation(nativeOfflineAudioContext, proxy.positionZ, nativePannerNode.positionZ, trace);

              case 25:
                _context4.next = 39;
                break;

              case 27:
                _context4.next = 29;
                return connectAudioParam(nativeOfflineAudioContext, proxy.orientationX, nativePannerNode.orientationX, trace);

              case 29:
                _context4.next = 31;
                return connectAudioParam(nativeOfflineAudioContext, proxy.orientationY, nativePannerNode.orientationY, trace);

              case 31:
                _context4.next = 33;
                return connectAudioParam(nativeOfflineAudioContext, proxy.orientationZ, nativePannerNode.orientationZ, trace);

              case 33:
                _context4.next = 35;
                return connectAudioParam(nativeOfflineAudioContext, proxy.positionX, nativePannerNode.positionX, trace);

              case 35:
                _context4.next = 37;
                return connectAudioParam(nativeOfflineAudioContext, proxy.positionY, nativePannerNode.positionY, trace);

              case 37:
                _context4.next = 39;
                return connectAudioParam(nativeOfflineAudioContext, proxy.positionZ, nativePannerNode.positionZ, trace);

              case 39:
                if (!isNativeAudioNodeFaker(nativePannerNode)) {
                  _context4.next = 44;
                  break;
                }

                _context4.next = 42;
                return renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativePannerNode.inputs[0], trace);

              case 42:
                _context4.next = 46;
                break;

              case 44:
                _context4.next = 46;
                return renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativePannerNode, trace);

              case 46:
                return _context4.abrupt("return", nativePannerNode);

              case 47:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function createAudioNode(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    return {
      render: function render(proxy, nativeOfflineAudioContext, trace) {
        var renderedNativeGainNodeOrNativePannerNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);

        if (renderedNativeGainNodeOrNativePannerNode !== undefined) {
          return Promise.resolve(renderedNativeGainNodeOrNativePannerNode);
        }

        return createAudioNode(proxy, nativeOfflineAudioContext, trace);
      }
    };
  };
};